import React from 'react'
import { EditRateFlowProvider } from './context/EditRateFlowProvider'
import { EditRateFlowMain } from './components/EditRateFlowMain'
import { useRuleDetailContextValue } from '../../context/RuleDetailProvider'

export const EditRateFlow = () => {
  const {
    state: { id: ruleId },
  } = useRuleDetailContextValue()

  return (
    <EditRateFlowProvider ruleId={ruleId}>
      <EditRateFlowMain />
    </EditRateFlowProvider>
  )
}
